import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["queryField", "value"];
import { stringify as stringifyParams } from 'hub-http/helpers/params';
import { useCallback, useMemo } from 'react';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { getModulesStorefrontRoute, getThemesStorefrontRoute } from '../../utils/urls';
import { useRouteOfferingType } from '../hooks/useRouteOfferingType';
import { getQueryFieldUrl } from '../utils/assetQuery';
import { jsx as _jsx } from "react/jsx-runtime";
export default function RouterFilterButton(_ref) {
  let {
      queryField,
      value
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const offeringType = useRouteOfferingType();
  const getRoute = useCallback((path, paramsString = '') => {
    return offeringType === 'MODULE' ? path ? getModulesStorefrontRoute(path) : `${getModulesStorefrontRoute()}?${paramsString}` : path ? getThemesStorefrontRoute(path) : `${getThemesStorefrontRoute()}?${paramsString}`;
  }, [offeringType]);
  const computedLocation = useMemo(() => {
    const paramsString = stringifyParams({
      [`eco_${queryField}`]: value
    });
    let path;
    if (Array.isArray(value) && value.length === 1) {
      path = getQueryFieldUrl(queryField, value[0]);
    } else if (typeof value === 'string') {
      path = getQueryFieldUrl(queryField, value);
    }
    return getRoute(path, paramsString);
  }, [getRoute, queryField, value]);
  return /*#__PURE__*/_jsx(RouterButton, Object.assign({}, rest, {
    to: computedLocation
  }));
}